import { Component } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { OeAppService } from '../../shared/oe-app.service';
import { ActivationPlacementExamModalComponent } from '../activation-placement-exam-modal/activation-placement-exam-modal.component';

@Component({
  selector: 'lp2-activation-placement-exam-overlay',
  templateUrl: './activation-placement-exam-overlay.component.html',
  styleUrls: ['./activation-placement-exam-overlay.component.scss'],
})
export class ActivationPlacementExamOverlayComponent {
  displayPlacementExamOverlay = false;

  constructor(private readonly ngbModal: NgbModal, oeAppService: OeAppService) {
    this.displayPlacementExamOverlay =
      !oeAppService.isActivationPlacementTestEnabled() &&
      oeAppService.getData('person').id &&
      !oeAppService.getData('person').oePlacementTestTaken;
  }

  showPlacementTestModal() {
    const placementTestModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
    };
    this.ngbModal.open(ActivationPlacementExamModalComponent, placementTestModalOptions);
  }
}



// WEBPACK FOOTER //
// ./ts/app/overlay/activation-placement-exam-overlay/activation-placement-exam-overlay.component.ts